import { useContext } from "react";

import { viewModelClassesContext } from "@lib/viewModelClassesContext";

/**
 * This is a support hook for providing view model classes in production.
 * It is also used when mocking view models with dependency injection in storybook
 */
export const useViewModelClasses = () => {
  return useContext(viewModelClassesContext);
};
